import { fetchApi } from '@/config/axiosSetting.ts';
import { PersonalInformationOwnerResponseType } from '@/modules/adjusterReportModules/IncidentParticipants/types/OwnerType';

export const getCulpritUserInformationQueryFunction = (
  id: number,
): Promise<PersonalInformationOwnerResponseType> =>
  fetchApi({
    url: `/property/reports/${id}/accident_users/culprit/user_information/owner/`,
  });
